import React from 'react';
import { Box, ListItemText, Card, IconButton, FormLabel, FormGroup, MenuItem, Select, Grid, Button } from '@mui/material';
import BasePopover from '../popover/base-popover.component';
import { FilterList } from '@mui/icons-material';
import './scss/toolbar-popover.scss';
import _ from 'lodash';

/**
 * 过滤器
 */
export default function ToolbarFiltterPopover(props: {
    selects: FillterSelects[];
    changeCallback: (selectValues: { [key: string]: string[] }, chips: { label: string, value: string, onDelete: () => void }[]) => void;
}) {

    const { selects, changeCallback } = props;

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const [selectValues, setSelectValues] = React.useState<{ [key: string]: string[] }>({});
    const change = (val: { [key: string]: string[] }) => {
        setSelectValues(val);
        const chips = selectLabels(val, selects);
        changeCallback(val, chips);

    }
    // 已经选择的标签
    const selectLabels = (selectValues: { [key: string]: string[] }, selects: FillterSelects[]) => {
        const chips: { label: string; value: string; onDelete: () => void }[] = [];

        _.mapKeys(selectValues, (value, key) => {

            selects.forEach((item) => {

                if (key === item.key && item.optionValues?.length) {

                    item.optionValues.forEach((optionItem) => {

                        value?.forEach((iitem, index) => {
                            if (iitem === optionItem.value) {
                                chips.push({
                                    ...optionItem,
                                    label: `${item.title}:${optionItem.label}`,
                                    onDelete: () => {
                                        const newVlaues = value;
                                        newVlaues.splice(index, 1);
                                        selectValues[key] = newVlaues;
                                        change(selectValues);
                                    }
                                })
                            }

                        })
                    });

                }
            })
        })
        return chips
    }


    return (
        <>
            <IconButton onClick={(e) => { setAnchorEl(e.currentTarget) }}><FilterList /></IconButton>
            <BasePopover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                id='toolbar-filtter-popover'
            >
                <Card className='toolbar-filtter-popover-content' style={{ width: '500px' }}>
                    <Box><Button onClick={() => { change({}) }}>RESET</Button></Box>
                    <Grid container spacing={4} >
                        {selects.map((item) => {
                            const renderValue = _.compact(item.optionValues.map((iitem) => {
                                if ((selectValues[item.key])?.includes(iitem.value)) {
                                    return iitem.label
                                }
                                return false
                            }))?.join(',') as React.ReactNode
                            return (
                                <Grid item xs={6} key={item.key}>
                                    <FormLabel>{item.title}</FormLabel>
                                    <FormGroup style={{ overflow: 'hidden', flexWrap: 'unset' }}>
                                        <Select
                                            multiple
                                            value={selectValues[item.key] || []}
                                            renderValue={() => renderValue}
                                            onChange={(event) => {
                                                const newValue = selectValues;
                                                newValue[item.key] = event.target.value as string[];
                                                change({ ...newValue });
                                            }}

                                        >
                                            {item.optionValues.map((iitem, oIndex) => (
                                                <MenuItem key={`${iitem.value}${oIndex}`} value={iitem.value}>
                                                    <ListItemText primary={iitem.label} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormGroup>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Card>
            </BasePopover >
        </>
    )
}
export type FillterSelects = {
    title: string;
    key: string;
    value: string[];
    optionValues: {
        label: string;
        value: string;
    }[];
}